import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgABoats = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 20"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="m21.767 12.674-.001-.02V9.438a.803.803 0 1 1 1.608 0v2.987c1.972-.287 3.629-.452 4.721-.452h31.092c1.23-.76 1.607-1.727 1.607-1.727s1.152-6.909 1.269-8.29C62.176.572 63.829 0 63.829 0h29.666c2.88 0 4.605 1.61 4.605 1.61l6.683 9.254c6.524-.337 12.423-.618 15.538-.618h45.597c4.03 0 8.981 1.38 8.981 1.38l14.716 6.309.597-8.322s1.267-.634 3.801-.634c2.533 0 5.987.634 5.987.634v9.614H0c.7-2.016 13.263-5.162 21.767-6.553"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgABoats
